var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"wxTaskInfo"}},[_c('BackApprove',{attrs:{"title":"审批详情"}}),_c('iframe',{attrs:{"src":_vm.src}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }